import type { ReactNode } from "react";
import { Container, Stack } from "@generalapplications/ui";

import { RichContent, type FigureComponentRegistry } from "./RichContent";
import type { BlogPostBlock } from "@/content/blog";

export type ArticleContentProps = {
  blocks: BlogPostBlock[];
  figureComponents: FigureComponentRegistry;
  /** The headline and lede, drawn first in the same column as the body. */
  lead?: ReactNode;
};

// The article body: the full width of the page, headline first, the blocks
// in the library's reading rhythm. Headings carry ids, so a section can be
// linked to.
export function ArticleContent({
  blocks,
  figureComponents,
  lead,
}: ArticleContentProps) {
  return (
    <Container as="article" width="xl">
      <Stack gap="lg">
        {lead}
        <RichContent blocks={blocks} figureComponents={figureComponents} />
      </Stack>
    </Container>
  );
}
